var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divplus"},[_vm._t("default"),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divplus-edge"},[_c('div',{staticClass:"divplus-etl"}),_c('div',{staticClass:"divplus-etr"}),_c('div',{staticClass:"divplus-ebl"}),_c('div',{staticClass:"divplus-ebr"})])
}]

export { render, staticRenderFns }